import {
    AllEnvironmentName,
    EnvironmentName,
    LocalEnvironmentName,
    MystiqueEnvironmentHost,
    StargateEnvironmentHost,
} from "waapi/environments-repository/constants/environments.js";

export const ENVIRONMENT_HOSTS: Record<MystiqueEnvironmentHost, AllEnvironmentName> = {
    [MystiqueEnvironmentHost.PROD]: EnvironmentName.PROD,
    [MystiqueEnvironmentHost.KAPPA]: EnvironmentName.KAPPA,
    [MystiqueEnvironmentHost.ALPHA]: EnvironmentName.ALPHA,
    [MystiqueEnvironmentHost.BETA]: EnvironmentName.BETA,
    [MystiqueEnvironmentHost.GAMMA]: EnvironmentName.GAMMA,
    [MystiqueEnvironmentHost.LOCAL]: LocalEnvironmentName.LOCAL,
    [MystiqueEnvironmentHost.LOCAL2]: LocalEnvironmentName.LOCAL2,
    [MystiqueEnvironmentHost.DELTA]: EnvironmentName.DELTA,
    [MystiqueEnvironmentHost.EPSILON]: EnvironmentName.EPSILON,
    [MystiqueEnvironmentHost.LAMBDA]: EnvironmentName.LAMBDA,
    [MystiqueEnvironmentHost.OMEGA]: EnvironmentName.OMEGA,
    [MystiqueEnvironmentHost.ZETA]: EnvironmentName.ZETA,
    [MystiqueEnvironmentHost.SIGMA]: EnvironmentName.SIGMA,
    [MystiqueEnvironmentHost.THETA]: EnvironmentName.THETA,
    [MystiqueEnvironmentHost.IOTA]: EnvironmentName.IOTA,
    [MystiqueEnvironmentHost.PSI]: EnvironmentName.PSI,
    [MystiqueEnvironmentHost.NU]: EnvironmentName.NU,
    [MystiqueEnvironmentHost.MU]: EnvironmentName.MU,
    [MystiqueEnvironmentHost.CHI]: EnvironmentName.CHI,
    [MystiqueEnvironmentHost.RHO]: EnvironmentName.RHO,
    [MystiqueEnvironmentHost.FAKER]: EnvironmentName.FAKER,
    [MystiqueEnvironmentHost.OMICRON]: EnvironmentName.OMICRON,
    [MystiqueEnvironmentHost.UMI]: EnvironmentName.UMI,
    [MystiqueEnvironmentHost.HADES]: EnvironmentName.HADES,
    [MystiqueEnvironmentHost.VOLDEMORT]: EnvironmentName.VOLDEMORT,
};

export const ENVIRONMENT_HOSTS_STARGATE: Record<MystiqueEnvironmentHost, StargateEnvironmentHost> = {
    [MystiqueEnvironmentHost.PROD]: StargateEnvironmentHost.PROD,
    [MystiqueEnvironmentHost.KAPPA]: StargateEnvironmentHost.KAPPA,
    [MystiqueEnvironmentHost.ALPHA]: StargateEnvironmentHost.ALPHA,
    [MystiqueEnvironmentHost.BETA]: StargateEnvironmentHost.BETA,
    [MystiqueEnvironmentHost.GAMMA]: StargateEnvironmentHost.GAMMA,
    [MystiqueEnvironmentHost.LOCAL]: StargateEnvironmentHost.LOCAL,
    [MystiqueEnvironmentHost.LOCAL2]: StargateEnvironmentHost.LOCAL,
    [MystiqueEnvironmentHost.DELTA]: StargateEnvironmentHost.DELTA,
    [MystiqueEnvironmentHost.EPSILON]: StargateEnvironmentHost.EPSILON,
    [MystiqueEnvironmentHost.LAMBDA]: StargateEnvironmentHost.LAMBDA,
    [MystiqueEnvironmentHost.OMEGA]: StargateEnvironmentHost.OMEGA,
    [MystiqueEnvironmentHost.ZETA]: StargateEnvironmentHost.ZETA,
    [MystiqueEnvironmentHost.SIGMA]: StargateEnvironmentHost.SIGMA,
    [MystiqueEnvironmentHost.THETA]: StargateEnvironmentHost.THETA,
    [MystiqueEnvironmentHost.IOTA]: StargateEnvironmentHost.IOTA,
    [MystiqueEnvironmentHost.PSI]: StargateEnvironmentHost.PSI,
    [MystiqueEnvironmentHost.NU]: StargateEnvironmentHost.NU,
    [MystiqueEnvironmentHost.MU]: StargateEnvironmentHost.MU,
    [MystiqueEnvironmentHost.CHI]: StargateEnvironmentHost.CHI,
    [MystiqueEnvironmentHost.RHO]: StargateEnvironmentHost.RHO,
    [MystiqueEnvironmentHost.FAKER]: StargateEnvironmentHost.FAKER,
    [MystiqueEnvironmentHost.OMICRON]: StargateEnvironmentHost.OMICRON,
    [MystiqueEnvironmentHost.UMI]: StargateEnvironmentHost.UMI,
    [MystiqueEnvironmentHost.HADES]: StargateEnvironmentHost.HADES,
    [MystiqueEnvironmentHost.VOLDEMORT]: StargateEnvironmentHost.VOLDEMORT,
};
